import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfig, CMPS_APP_CONFIG } from '../../../../app.config';
import { catchErrorLogRet } from '../../../../common/rest.operators';

import { WpDataRowParamsAtSegment } from './model/data-row/wp-data-row-params-at-segment.model';
import { WpDisplayConfig } from './model/display-config/wp-display-config.model';
import { ViewRow } from './model/view/view-row.model';
import { WpViewTable } from './model/view/wp-view-table.model';

@Injectable()
export class WinningPercentageService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    retrieveDisplayConfig(userId: number): Observable<WpDisplayConfig> {
        const params = new HttpParams().set('userId', String(userId));
        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.COACHING}/winning-percentage/display-config`,
                { params },
            )
            .pipe(catchErrorLogRet({}));
    }

    retrieveViewTable(
        userId: number,
        dataRangeId?: number,
        evaluationRangeId?: number,
        drillPathIdentifier?: string,
    ): Observable<WpViewTable> {
        let params = new HttpParams().set('userId', String(userId));
        if (dataRangeId != null) {
            params = params.set('dataRangeId', String(dataRangeId));
        }
        if (evaluationRangeId != null) {
            params = params.set('evaluationRangeId', String(evaluationRangeId));
        }
        if (drillPathIdentifier != null) {
            params = params.set('drillPathIdentifier', drillPathIdentifier);
        }
        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.COACHING}/winning-percentage/table`,
                { params },
            )
            .pipe(catchErrorLogRet({}));
    }

    listRows(
        userId: number,
        drillPathIdentifier: string,
        segmentIdentifier: string,
        paramsAtSegment: WpDataRowParamsAtSegment,
    ): Observable<ViewRow[]> {
        const params = new HttpParams()
            .set('userId', String(userId))
            .set('drillPathIdentifier', drillPathIdentifier)
            .set('segmentIdentifier', segmentIdentifier);
        return this._http
            .post(
                `${this._appConfig.API_ENDPOINTS.COACHING}/winning-percentage/rows`,
                paramsAtSegment,
                { params },
            )
            .pipe(catchErrorLogRet([]));
    }
}
